import React from 'react';
import PropTypes from 'prop-types';
import IconLink from '@cotyorg/ccx-molecules/IconLink';

const HeaderLogo = ({
  logoCssClass,
  logoSrc,
  logoAlt = '',
  logoLinkText = '',
  homeLink = '/',
  logoWidth,
  logoHeight,
}) => (
  <div className={logoCssClass}>
    <IconLink
      testAttribute="header-logo-link"
      iconExtraClass="header__logo-image"
      extraClass="no-underline"
      iconSrc={logoSrc}
      iconAlt={logoAlt}
      link={homeLink}
      iconWidth={logoWidth}
      iconHeight={logoHeight}
    />
  </div>
);

HeaderLogo.propTypes = {
  logoCssClass: PropTypes.string,
  logoSrc: PropTypes.string.isRequired,
  logoAlt: PropTypes.string,
  logoLinkText: PropTypes.string.isRequired,
  homeLink: PropTypes.string,
  logoWidth: PropTypes.number,
  logoHeight: PropTypes.number,
};

export default HeaderLogo;
